import React from 'react'; 
import PropTypes from 'prop-types';


export default function FiledCheckbox({ name, labelValue, handleChange, value }) {
  const fieldProps = { 
    type: 'checkbox',
    name,
    className: `form-filed__inp-checkbox`,
    onChange: () => handleChange({ target: { name, value: !value} }),
    checked: value
  }

  return (
    <div className='form-filed form-filed--checkbox'>
      <label className='form-filed__label'>
        { labelValue && <span className='s-result-form__label-value'>{labelValue}</span>}
        <input { ...fieldProps } />
        <span className='form-filed__toggle' />
      </label>
      
    </div>
  )
}

FiledCheckbox.propTypes = {
  handleChange: PropTypes.func,
  value: PropTypes.bool,
  readOnly: PropTypes.bool
}